import React, { useEffect, useState } from "react";
import { HiEye } from "react-icons/hi";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { FaStar, FaStarHalfAlt, FaRegStar, FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";
import 'yet-another-react-lightbox/styles.css';
import Lightbox from 'yet-another-react-lightbox';
import Swal from 'sweetalert2';
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdClose, MdDelete, MdModeEdit, MdVerified } from "react-icons/md";
import ApiClient from "../../api-client";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Label,
  Spinner,
  CardImg,
  Table,
} from "reactstrap";
import Map from "../../views/Map";
import pdf from "../../assets/img/pdf.svg"

function ProviderServiceDetails() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [alertLoader, setAlertLoader] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [userRating, setUserRating] = useState(0);
    const [url, setUrl] = useState(null);
    const [showAlter, setShowAlter] = useState(false);
    const [userServiceDetails, setUserServiceDetails] = useState([]);
    const fullStars = Math.floor(userRating);
    const hasHalfStar = userRating % 1 !== 0;
    const emptyStars = 5 - Math.ceil(userRating);
    const [action, setAction] = useState(null);
    const [serviceId, setServiceId] = useState(null);

    const openLightbox = (originalUrl) => {
        setUrl(originalUrl);
        setIsOpen(true);
    };
    const closeLightbox = () => {
        setIsOpen(false);
        setUrl(null);
    };

    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");

    const fetchDetails = async () => {
        try {
            setLoader(true);
            const getDetails = await ApiClient.get(
                `api/service/get-service-by-id/${id}`,
                "",
                true,
                dispatch
            );

            if (getDetails?.body) {
                setUserDetails(getDetails?.body);
            }
            setLoader(false);
        } catch (error) {
            toast.error(error.message, { autoClose: 3000 });
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchDetails();
    }, []);


    const loadDocuments = (
        thumbnailDocuments,
        name,
        originalthumbnailDocuments
      ) => {
    
        return  thumbnailDocuments.map((document, index) => {
          const isPdf = document.key.endsWith('.pdf');
               return (
                        isPdf ? (
                        <div
                          key={index}
                          className="image-card-container"    
                        >
                            <Card className="image-card">
                                <CardImg top width="100%" src={pdf} alt="Card image cap" />
                                <CardBody>
                                  <CardText>{name}</CardText>
                                </CardBody>
                                <div className="overlay">
                                  <a href={originalthumbnailDocuments[index]?.url} target="_blank">
                                  <HiEye className="icon"/>
                                  </a>
                                </div>
                              </Card>
                              </div>) :
                               (<div
                              key={index}
                              className="image-card-container"
                              onClick={() => openLightbox(originalthumbnailDocuments[index]?.url)}
                            >
                             <>
                            <Card className="image-card">
                              <CardImg top width="100%" src={document.url} alt="Card image cap" />
                              <CardBody>
                                <CardText>{name}</CardText>
                              </CardBody>
                              <div className="overlay">
                                <HiEye className="icon" />
                              </div>
                            </Card>
                          </>
                          </div>)
                              );
                          });
                          };
    

    const formatDate = dateString => new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });


    const openAlertDialog = (id, action) => {
        setServiceId(id);
        setAction(action);
        setShowAlter(true);
    
      };


  const handleStatus = async () => {
    if (serviceId) {
      try {
        setAlertLoader(true);
        const updateUserStatus = await ApiClient.put(
          `api/service/update-service-status/${serviceId}`,
          { action: "status", actionValue: action },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        // fetchServiceDetails();
        fetchDetails()
        toast.success(updateUserStatus.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

    return (
        <>
            <div className="content">
                <Button
                    color="primary"
                    className="ml-10 common-button"
                    onClick={() => navigate("/admin/provider/list")}
                >
                    <IoMdArrowRoundBack /> Back
                </Button>
                <Container>
                    {loader && (
                        <span className="table-loader">
                            <Spinner color="primary">Loading...</Spinner>
                        </span>
                    )}
                    {!loader && (
                        <>
                            <Card>
                                <CardBody className="mb-15">
                                    <div>
                                        <Row>
                                            <Col md="10">
                                                <div className="card-heading">
                                                    <Label>Service Details</Label>
                                                </div>
                                            </Col>
                                            <Col md="2">
                                            {userDetails?.status && userDetails?.status == "activated" ? (
                                                <Button
                                                onClick={() =>
                                                    openAlertDialog(userDetails?._id, "deactivated")
                                                }
                                                className="common-button"
                                                >
                                                Activated
                                                </Button>
                                            ) : (
                                                <Button
                                                onClick={() =>
                                                    openAlertDialog(userDetails?._id, "activated")
                                                }
                                                className="common-button-danger"
                                                >
                                                Deactivated
                                                </Button>
                                            )}
                                        </Col>
                                        </Row>
                                    </div>
                                    <div>
                                        <Row>
                                            <Col md="12">
                                                <CardBody>
                                                    {/* Service Title */}
                                                    <Row className="mt-3">
                                                        <Col md="12">
                                                            <strong>Service Title:</strong>{" "}
                                                            {userDetails?.serviceTitle ? userDetails?.serviceTitle : "-"}
                                                        </Col>
                                                    </Row>
                                                    {/* Service Category and Subcategory */}
                                                    <Row className="mt-3">
                                                        <Col md="4">
                                                            <strong>Service Category:</strong>{" "}
                                                            {userDetails?.categoryId?.categoryName ? userDetails?.categoryId?.categoryName : "-"}
                                                        </Col>
                                                        <Col md="4">
                                                            <strong>Service Subcategory:</strong>{" "}
                                                            {userDetails?.subcategoryId?.subCategoryName ? userDetails?.subcategoryId?.subCategoryName : "-"}
                                                        </Col>
                                                    </Row>
                                                    {/* Pricing Details */}
                                                    <Row className="mt-3">
                                                        <Col md="4">
                                                            <strong>Common Location Price:</strong>{" "}
                                                            {userDetails?.pricing?.commonLocation?.price ? userDetails?.pricing?.commonLocation?.price + '$': "-"}
                                                        </Col>
                                                        <Col md="4">
                                                            <strong>Home Visit Price:</strong>{" "}
                                                            {userDetails?.pricing?.homeVisit?.price ? userDetails?.pricing?.homeVisit?.price + '$': "-"}
                                                        </Col>
                                                        <Col md="4">
                                                            <strong>Online Price:</strong>{" "}
                                                            {userDetails?.pricing?.online?.price ? userDetails?.pricing?.online?.price + '$' : "-"}
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-3">
                                                        <Col md="4">
                                                            <strong>Extra Charges Price:</strong>{" "}
                                                            {userDetails?.extraCharges ? userDetails?.extraCharges + '$' : "-"}
                                                        </Col>
                                                        <Col md="4">
                                                            <strong>Max People Allowed:</strong>{" "}
                                                            {userDetails?.maxPeopleAllowed ? userDetails?.maxPeopleAllowed : "-"}
                                                        </Col>
                                                        <Col md="4">
                                                            <strong>Number Of People Included:</strong>{" "}
                                                            {userDetails?.numberOfPeopleIncluded ? userDetails?.numberOfPeopleIncluded : "-"}
                                                        </Col>
                                                    </Row>
                                                    {/* Experience, Qualification, and Specialties */}
                                                    <Row className="mt-3">
                                                        <Col md="4">
                                                            <strong>Specialties:</strong>{" "}
                                                            {userDetails?.specialities ? userDetails?.specialities : "-"}
                                                        </Col>
                                                        <Col md="4">
                                                            <strong>Qualifications:</strong>{" "}
                                                            {userDetails?.qualification ? userDetails?.qualification : "-"}
                                                        </Col>
                                                        <Col md="4">
                                                            <strong>Experience:</strong>{" "}
                                                            {userDetails?.experience ? userDetails?.experience : "-"}
                                                        </Col>
                                                    </Row>
                                                    {/* Service Description */}
                                                    <Row className="mt-3">
                                                        <Col md="12">
                                                            <strong>Service Description:</strong>{" "}
                                                            {userDetails?.description ? userDetails?.description : "-"}
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Col>
                                        </Row>

                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody className="mb-15">
                                    <div className="card-heading">
                                        <Label>Portfolio Images </Label>
                                    </div>
                                    <div className="document-flex-box">
                                        {userDetails?.portfolioImageThumbnail?.length > 0 &&
                                            loadDocuments(
                                                userDetails?.portfolioImageThumbnail,
                                                "Portfolio Images",
                                                userDetails?.portfolioImage
                                            )}                                 
                                    </div>
                                    {isOpen && (
                                        <Lightbox mainSrc={url} onCloseRequest={closeLightbox} />
                                    )}
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody className="mb-15">
                                    <div className="card-heading">
                                        <Label>License Documents </Label>
                                    </div>
                                    <div className="document-flex-box">
                                        {userDetails?.licenseImageThumbnail?.length > 0 &&
                                            loadDocuments(
                                                userDetails?.licenseImageThumbnail,
                                                "License Document",
                                                userDetails?.licenseImage
                                            )}                                 
                                    </div>
                                    {isOpen && (
                                        <Lightbox mainSrc={url} onCloseRequest={closeLightbox} />
                                    )}
                                </CardBody>
                            </Card>
                            <Card>
                            <CardBody className="mb-15">
                            <div className="card-heading">
                                <Label>Service Location</Label>
                                <Map lattitude ={userDetails?.loc?.coordinates[0]} longitude={userDetails?.loc?.coordinates[1]}/>
                            </div>
                            </CardBody>
                        </Card>

                          {showAlter && (
                                    <Swal
                                    info
                                    showCancel
                                    confirmBtnText={
                                        alertLoader ? (
                                        <span>
                                            Confirm <Spinner size="sm" />
                                        </span>
                                        ) : (
                                        "Confirm"
                                        )
                                    }
                                    confirmBtnBsStyle="info"
                                    title="Are you sure?"
                                    onConfirm={handleStatus}
                                    onCancel={() => setShowAlter(false)}
                                    focusCancelBtn
                                    >
                                    You want to {action} this service.
                                    </Swal>
                                )}
                        </>
                    )}
                </Container>
            </div>
        </>
    );
}

export default ProviderServiceDetails;
